import ShaftDashboard from '@/components/shaftsV2/dashboard/dashboard.vue';
import ShaftInspectionDetails from '@/components/shafts/inspections/inspection_details.vue';
import ShaftInspections from '@/components/shafts/inspections/inspections.vue';
import ShaftLayout from '@/components/shafts/shaft_layout.vue';
import ShaftV2Definition from '@/components/shaftsV2/definition/definition.vue';
import ShaftV2Form from '@/components/shaftsV2/operations/shaftV2_form.vue';
import ShaftV2HmeForm from '@/components/shaftsV2/operations/heavy_mobile_equipment_form.vue';
import ShaftV2StationForm from '@/components/shaftsV2/operations/station_form.vue';
import ShaftIssueForm from '@/components/shafts/issue_form.vue';
import ShaftV2IssuesSet from '@/components/shaftsV2/issues/issues_set.vue';
import ShaftV2IssuesStation from '@/components/shaftsV2/issues/issues_station.vue';
import ShaftV2IssuesOverview from '@/components/shaftsV2/issues/issues_overview.vue';
import ShaftV2IssuesHme from '@/components/shaftsV2/issues/issues_hme.vue';
import ShaftIssueLocationSets from '@/components/shaftsV2/location/issue_location_sets.vue';
import ShaftIssueLocationDiagram from '@/components/shaftsV2/location/issue_location_diagram.vue';
import ShaftV2Configurations from '@/components/shaftsV2/configuration/configuration_page.vue';
import ShaftV2ManageRegionsStation from '@/components/shaftsV2/regions/manage_regions_station.vue';
import ShaftV2ManageRegionsHme from '@/components/shaftsV2/regions/manage_regions_hme.vue';
import ShaftV2Tasks from '@/components/shaftsV2/tasks/tasks.vue';
import ShaftV2TaskList from '@/components/shaftsV2/tasks/task_list.vue';
import ShaftV2IssueList from '@/components/shaftsV2/tasks/issue_list.vue';
import ShaftV2HealthReportForm from '@/components/shaftsV2/shaft_health_report/shaft_health_report_form.vue';
import ShaftV2IssueHistory from '@/components/issues/issue_history.vue';

import RegionsIssue from '@/components/regions/shaftsV2_regions_issue_view.vue';
import RegionsIssueLocation from '@/components/regions/shaftsV2_regions_issue_location.vue';

import only from '../only';

export default [
  {
    path: 'shafts_v2/new',
    name: 'newShaftV2',
    component: ShaftV2Form,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/edit',
    name: 'editShaftV2',
    component: ShaftV2Form,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId',
    name: 'shaftV2',
    component: ShaftLayout,
    props: true,
    redirect: { name: 'shaftV2Dashboard' },
    children: [
      {
        path: '',
        name: 'shaftV2Dashboard',
        component: ShaftDashboard,
        props: true,
      },
      {
        path: ':scope(inspections|approved_inspections)',
        name: 'shaftV2Inspections',
        component: ShaftInspections,
        props: only('organisationId', 'shaftId', 'scope'),
        children: [
          {
            path: ':inspectionId',
            name: 'shaftV2Inspection',
            component: ShaftInspectionDetails,
            props: true,
          },
        ],
      },
      {
        path: 'issues',
        name: 'shaftV2Issues',
        component: ShaftV2IssuesSet,
        props: true,
        children: [
          {
            path: ':issueType(sets)',
            name: 'shaftV2IssuesTypeSets',
            component: ShaftV2IssuesSet,
            props: true,
            children: [
              {
                path: ':setNumber',
                name: 'shaftV2IssuesTypeSet',
                component: ShaftV2IssuesSet,
                props: true,
              },
              {
                path: ':setNumber/inspections/:inspectionId/issues/:issueId',
                name: 'shaftV2RegionsIssuesTypeSet',
                component: RegionsIssue,
                props: true,
              },
              {
                path: ':setNumber/inspections/:inspectionId/issues/:issueId/location/sets/:setId',
                name: 'shaftV2IssuesLocationTypeSet',
                component: RegionsIssueLocation,
                props: true,
              },
            ],
          },
        ],
      },
      {
        path: 'issues/:issueType(stations)',
        name: 'shaftV2IssuesTypeStations',
        component: ShaftV2IssuesStation,
        props: true,
        children: [
          {
            path: ':stationId',
            name: 'shaftV2IssuesTypeStation',
            component: ShaftV2IssuesStation,
            props: true,
          },
          {
            path: ':stationId/inspections/:inspectionId/issues/:issueId',
            name: 'shaftV2RegionsIssuesTypeStation',
            component: RegionsIssue,
            props: true,
          },
          {
            path: 'inspections/:inspectionId/issues/:issueId/location/station/:stationId',
            name: 'shaftV2IssuesLocationTypeStation',
            component: RegionsIssueLocation,
            props: true,
          },
        ],
      },
      {
        path: 'issues/:issueType(overview)',
        name: 'shaftV2IssuesOverview',
        component: ShaftV2IssuesOverview,
        props: true,
        children: [
          {
            path: ':setGroupId',
            name: 'shaftV2IssuesOverviewGroup',
            component: ShaftV2IssuesOverview,
            props: true,
          },
          {
            path: ':setGroupId/inspections/:inspectionId/issues/:issueId',
            name: 'shaftV2RegionsIssuesTypeOverviewGroupId',
            component: RegionsIssue,
            props: true,
          },
          {
            path: 'inspections/:inspectionId/issues/:issueId',
            name: 'shaftV2RegionsIssuesTypeOverviewGroup',
            component: RegionsIssue,
            props: true,
          },
          {
            path: ':setGroupId/inspections/:inspectionId/issues/:issueId/location/sets/:setId',
            name: 'shaftV2IssuesLocationTypeOverviewId',
            component: RegionsIssueLocation,
            props: true,
          },
          {
            path: 'inspections/:inspectionId/issues/:issueId/location/sets/:setId',
            name: 'shaftV2IssuesLocationTypeOverview',
            component: RegionsIssueLocation,
            props: true,
          },
        ],
      },
      {
        path: 'issues/:issueType(heavy_mobile_equipment)',
        name: 'shaftV2IssuesTypeHmes',
        component: ShaftV2IssuesHme,
        props: true,
        children: [
          {
            path: ':heavyMobileEquipmentId',
            name: 'shaftV2IssuesTypeHme',
            component: ShaftV2IssuesHme,
            props: true,
            children: [
              {
                path: 'inspections/:inspectionId/issues/:issueId',
                name: 'shaftV2RegionsIssuesTypeHme',
                component: RegionsIssue,
                props: true,
              },
            ]
          },
          {
            path: 'inspections/:inspectionId/issues/:issueId/location/heavy_mobile_equipment/:heavyMobileEquipmentId',
            name: 'shaftV2IssuesLocationTypeHme',
            component: RegionsIssueLocation,
            props: true,
          },
        ],
      },
      {
        path: 'tasks',
        component: ShaftV2Tasks,
        props: only('organisationId', 'shaftId'),
        children: [
          {
            path: '',
            name: 'shaftV2Tasks',
            redirect: {
              name: 'shaftV2TasksCategory',
              params: { category: 'all' },
            },
          },
          {
            path: ':category(all|current|past_due|completed)',
            name: 'shaftV2TasksCategory',
            component: ShaftV2TaskList,
            props: true,
          },
          {
            path: ':category(issues_missing_tasks|resolved_issues)',
            name: 'shaftV2TaskIssuesCategory',
            component: ShaftV2IssueList,
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: 'shafts_v2/:shaftId/definition',
    name: 'shaftV2Definition',
    component: ShaftV2Definition,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/new',
    name: 'newShaftV2Issue',
    component: ShaftIssueForm,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/:issueId',
    name: 'shaftV2Issue',
    component: ShaftIssueForm,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/new/location/sets',
    name: 'shaftV2NewIssueLocationSets',
    component: ShaftIssueLocationSets,
    props: true,
    children: [
      {
        path: ':setId',
        name: 'shaftV2NewIssueLocationSet',
        component: ShaftIssueLocationSets,
        props: true,
      },
    ],
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/:issueId/location/sets',
    name: 'shaftV2IssueLocationSets',
    component: ShaftIssueLocationSets,
    props: true,
    children: [
      {
        path: ':setId',
        name: 'shaftV2IssueLocationSet',
        component: ShaftIssueLocationSets,
        props: true,
      },
    ],
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/new/location/stations',
    name: 'shaftV2NewIssueLocationStations',
    component: ShaftIssueLocationDiagram,
    props: true,
    children: [
      {
        path: ':stationId',
        name: 'shaftV2IssueLocationStation',
        component: ShaftIssueLocationDiagram,
        props: true,
      },
    ],
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/:issueId/location/stations',
    name: 'shaftV2IssueLocationStations',
    component: ShaftIssueLocationDiagram,
    props: true,
    children: [
      {
        path: ':stationId',
        name: 'shaftV2IssueLocationStation',
        component: ShaftIssueLocationDiagram,
        props: true,
      },
    ],
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/new/location/heavy_mobile_equipment',
    name: 'shaftV2NewIssueLocationHmes',
    component: ShaftIssueLocationDiagram,
    props: true,
    children: [
      {
        path: ':heavyMobileEquipmentId',
        name: 'shaftV2IssueLocationHme',
        component: ShaftIssueLocationDiagram,
        props: true,
      },
    ],
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/:issueId/location/heavy_mobile_equipment',
    name: 'shaftV2IssueLocationHmes',
    component: ShaftIssueLocationDiagram,
    props: true,
    children: [
      {
        path: ':heavyMobileEquipmentId',
        name: 'shaftV2IssueLocationHme',
        component: ShaftIssueLocationDiagram,
        props: true,
      },
    ],
  },
  {
    path: 'shafts_v2/:shaftId/configuration',
    name: 'shaftV2Configuration',
    component: ShaftV2Configurations,
    props: true,
    children: [
      {
        path: 'shaft',
        name: 'shaftV2ConfigurationShafts',
        component: ShaftV2Configurations,
        props: true,
      },
      {
        path: 'stations',
        name: 'shaftV2ConfigurationStations',
        component: ShaftV2Configurations,
        props: true,
      },
      {
        path: 'heavy_mobile_equipment',
        name: 'shaftV2ConfigurationHme',
        component: ShaftV2Configurations,
        props: true,
      },
    ],
  },
  {
    path: 'shafts_v2/:shaftId/stations/new',
    name: 'newShaftV2StationForm',
    component: ShaftV2StationForm,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/stations/:stationId',
    name: 'shaftV2StationForm',
    component: ShaftV2StationForm,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/stations/:stationId/regions/edit',
    name: 'shaftV2ManageRegions',
    component: ShaftV2ManageRegionsStation,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/heavy_mobile_equipment/:heavyMobileEquipmentId/regions/edit',
    name: 'shaftV2ManageRegionsHme',
    component: ShaftV2ManageRegionsHme,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/heavy_mobile_equipment/new',
    name: 'newShaftV2Hme',
    component: ShaftV2HmeForm,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/heavy_mobile_equipment/:heavyMobileEquipmentId/edit',
    name: 'editShaftV2Hme',
    component: ShaftV2HmeForm,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/shaft_health_reports/new',
    name: 'newShaftV2HealthReport',
    component: ShaftV2HealthReportForm,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/shaft_health_reports/:shaftHealthReportId/edit',
    name: 'editShaftV2HealthReport',
    component: ShaftV2HealthReportForm,
    props: true,
  },
  {
    path: 'shafts_v2/:shaftId/inspections/:inspectionId/issues/:issueId/history',
    name: 'shaftV2IssueHistory',
    component: ShaftV2IssueHistory,
    props: true,
  },
];
